import {
  media,
  SafeHtml,
  SafeHtmlProps,
  Tile,
} from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledSafeHtml = styled<FC<SafeHtmlProps>>(SafeHtml)`
  img {
    max-width:-webkit-fill-available;
  }
  font-size: 14px;
`;

export const StyledTime = styled.div`
font-size: 14px;
font-weight: 600;
line-height: 18px;
padding-bottom: 24px;
`;

export const StyledTile = styled(Tile)`
  h4 {
    margin-bottom: 16px;
    font-size: 24px;
  }
  ${media.lg`
    padding-right: 264px;
  `}
`;
